import React from 'react';
import { DocPageLayout } from '../../components/DocPageLayout';
import { CodeBlock } from '../../components/CodeBlock';
export function SdkCheckoutPage() {
  return <DocPageLayout title="Checkout SDK" description="Client-side JavaScript SDK for the hosted payment page integration." breadcrumbs={[{
    label: 'API Reference',
    id: 'api-overview'
  }, {
    label: 'SDKs'
  }, {
    label: 'Checkout'
  }]} data-id="element-792">
      <h2 className="text-2xl font-bold text-gray-900 mt-6 mb-4" data-id="element-793">
        Installation
      </h2>
      <CodeBlock language="HTML" title="Script Include" code={`<script src="https://test-gateway.mastercard.com/checkout/version/100/checkout.js"
        data-error="errorCallback"
        data-cancel="cancelCallback"
        data-complete="completeCallback">
</script>`} data-id="element-794" />
      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-795">
        Configuration
      </h2>
      <CodeBlock language="JavaScript" title="Checkout.configure()" code={`Checkout.configure({
  session: { id: "SESSION_ID" },
  interaction: {
    merchant: { name: "Your Store", logo: "https://your-site.com/logo.png" },
    displayControl: { billingAddress: "HIDE", customerEmail: "HIDE" }
  },
  order: { description: "Order #12345" }
});`} data-id="element-796" />
      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-797">Methods</h2>
      <div className="overflow-x-auto mb-8" data-id="element-798">
        <table className="w-full text-sm border border-gray-200 rounded-lg overflow-hidden" data-id="element-799">
          <thead data-id="element-800">
            <tr className="bg-gray-100" data-id="element-801">
              <th className="text-left px-4 py-3 font-semibold border-b" data-id="element-802">
                Method
              </th>
              <th className="text-left px-4 py-3 font-semibold border-b" data-id="element-803">
                Description
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-804">
            <tr data-id="element-805">
              <td className="px-4 py-3 font-mono text-xs" data-id="element-806">
                Checkout.configure(config)
              </td>
              <td className="px-4 py-3 text-gray-600" data-id="element-807">
                Configure the checkout with session and display options
              </td>
            </tr>
            <tr className="bg-gray-50" data-id="element-808">
              <td className="px-4 py-3 font-mono text-xs" data-id="element-809">
                Checkout.showPaymentPage()
              </td>
              <td className="px-4 py-3 text-gray-600" data-id="element-810">
                Redirect to the hosted payment page
              </td>
            </tr>
            <tr data-id="element-811">
              <td className="px-4 py-3 font-mono text-xs" data-id="element-812">
                Checkout.showLightbox()
              </td>
              <td className="px-4 py-3 text-gray-600" data-id="element-813">
                Show payment page as a lightbox overlay
              </td>
            </tr>
            <tr className="bg-gray-50" data-id="element-814">
              <td className="px-4 py-3 font-mono text-xs" data-id="element-815">
                Checkout.showEmbeddedPage(id)
              </td>
              <td className="px-4 py-3 text-gray-600" data-id="element-816">
                Embed the payment page in a container element
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </DocPageLayout>;
}